var map = {
	"./MEDICINSKI FAKULTET PRIJEMNI ISPIT 2016 .pdf": 274,
	"./MEDICINSKI FAKULTET PRIJEMNI ISPIT 2019.pdf": 921,
	"./MEDICINSKI FAKULTET PRIJEMNI ISPIT 2020.pdf": 224
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 971;